
<div class="container-fluid glb-popup">

  <h2> {{formTitle}}</h2>
  <p-toast [style]="{marginTop: '80px'}">
  </p-toast>
  @if (formLoading) {
    <div class="kbm-search-loading">
      <p-progressSpinner></p-progressSpinner>
    </div>
  }
  <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

  <button mat-icon-button [mat-dialog-close]="true" style="float:right;top:-50px;background-color: transparent;">
    <i class="pi pi-times" aria-hidden="true"></i>
  </button>
  <hr>
    @if (showGenerateForm && !showBulkGenerateForm && !showGenerateFormByDate) {
      <div [formGroup]="form1" class="forms w-100 d-block create-reservation-form">
        <div class="row">
          <div class="col-lg-12">
            <span class="p-float-label required-field w-100 mb-4">
              <p-dropdown appendTo="body" dropdownIcon="fa fa-caret-down" [options]="properties" formControlName="shortTermRentalId" optionLabel="propertyCode"
                optionValue="shortTermRentalId" [filter]="true" filterBy="propertyCode" [showClear]="false"
                placeholder="Select Property">
              </p-dropdown>
              <label for="Select Property">Select Property</label>
              @for (validation of validationMessages.shortTermRentalId; track validation) {
                <span>
                  @if (form1.get('shortTermRentalId').hasError(validation.type) && (form1.get('shortTermRentalId').dirty || form1.get('shortTermRentalId').touched)) {
                    <small class="p-invalid"
                      >{{validation.message}}
                    </small>
                  }
                </span>
              }
            </span>
          </div>
          <div class="col-lg-6  mb-4">
            <span class="p-float-label w-100">
              <p-dropdown appendTo="body" dropdownIcon="fa fa-caret-down" [options]="months" formControlName="month" optionLabel="name" optionValue="value" appendTo="body"
              placeholder="Month"></p-dropdown>
              <label for="month">Month</label>
              @for (validation of validationMessages.month; track validation) {
                <span>
                  @if (form1.get('month').hasError(validation.type) && (form1.get('month').dirty || form1.get('month').touched)) {
                    <small class="p-invalid"
                      >{{validation.message}}
                    </small>
                  }
                </span>
              }
            </span>
          </div>
          <div class="col-lg-6  mb-4">
            <span class="p-float-label w-100">
              <p-dropdown appendTo="body" dropdownIcon="fa fa-caret-down" [options]="years" formControlName="year" optionLabel="name" optionValue="value" appendTo="body"
              placeholder="Year"></p-dropdown>
              <label for="year">Year</label>
              @for (validation of validationMessages.year; track validation) {
                <span>
                  @if (form1.get('year').hasError(validation.type) && (form1.get('year').dirty || form1.get('year').touched)) {
                    <small class="p-invalid"
                      >{{validation.message}}
                    </small>
                  }
                </span>
              }
            </span>
          </div>
        </div>
        <div class="col-lg-12">
        </div>
      </div>
    }
    @if (showGenerateForm && !showBulkGenerateForm && !showGenerateFormByDate) {
      <hr>
      }
      @if (showGenerateForm && !showBulkGenerateForm && !showGenerateFormByDate) {
        <div class="row m-0">
          <div class="col-lg-12">
            <div class="btn-group">
              <div class="button-group">
              </div>
              <div class="button-group">
                <button pButton class="btn-cancel p-button-text" [mat-dialog-close]="true">Cancel</button>
                @if (!readOnlySubmitBotton) {
                  <button pButton class="btn-addt p-button" (click)="createReservation()">Generate</button>
                }
                @if (readOnlySubmitBotton) {
                  <button pButton class="btn-addt p-button" (click)="createReservation()" readonly="true">Submit</button>
                }
              </div>
            </div>
          </div>
        </div>
      }


      <!-- ============== Bulk generate statement form==================== -->
      @if (!showGenerateForm && showBulkGenerateForm && !showGenerateFormByDate) {
        <div [formGroup]="form2" class="forms w-100 d-block create-reservation-form">
          <div class="row">
            <div class="col-lg-6  mb-4">
              <span class="p-float-label w-100">
                <p-dropdown appendTo="body" dropdownIcon="fa fa-caret-down" [options]="monthsForBulkGenerateStatement" formControlName="month" optionLabel="name" optionValue="value" appendTo="body"
                placeholder="Month"></p-dropdown>
                <label for="month">Month</label>
                @for (validation of validationMessages.month; track validation) {
                  <span>
                    @if (form2.get('month').hasError(validation.type) && (form2.get('month').dirty || form2.get('month').touched)) {
                      <small class="p-invalid"
                        >{{validation.message}}
                      </small>
                    }
                  </span>
                }
              </span>
            </div>
            <div class="col-lg-6  mb-4">
              <span class="p-float-label w-100">
                <p-dropdown appendTo="body" dropdownIcon="fa fa-caret-down" [options]="yearsForBulkGenerateStatement" formControlName="year" optionLabel="name" optionValue="value" appendTo="body"
                placeholder="Year"></p-dropdown>
                <label for="year">Year</label>
                @for (validation of validationMessages.year; track validation) {
                  <span>
                    @if (form2.get('year').hasError(validation.type) && (form2.get('year').dirty || form2.get('year').touched)) {
                      <small class="p-invalid"
                        >{{validation.message}}
                      </small>
                    }
                  </span>
                }
              </span>
            </div>
          </div>
          <div class="col-lg-12">
          </div>
        </div>
      }
      @if (!showGenerateForm && showBulkGenerateForm && !showGenerateFormByDate) {
        <hr>
        }
        @if (!showGenerateForm && showBulkGenerateForm && !showGenerateFormByDate) {
          <div class="row m-0">
            <div class="col-lg-12">
              <div class="btn-group">
                <div class="button-group">
                </div>
                <div class="button-group">
                  <button pButton class="btn-cancel p-button-text" [mat-dialog-close]="true">Cancel</button>
                  @if (!readOnlySubmitBotton) {
                    <button pButton class="btn-addt p-button" (click)="generateBulkStatement()">Generate Bulk Statement</button>
                  }
                  @if (readOnlySubmitBotton) {
                    <button pButton class="btn-addt p-button" (click)="generateBulkStatement()" readonly="true">Submit</button>
                  }
                </div>
              </div>
            </div>
          </div>
        }


        @if (showGenerateFormByDate && !showBulkGenerateForm && !showGenerateForm) {
          <div [formGroup]="form3" class="forms w-100 d-block create-reservation-form">
            <div class="row">
              <div class="col-lg-12">
                <span class="p-float-label required-field w-100 mb-4">
                  <p-dropdown appendTo="body" dropdownIcon="fa fa-caret-down" [options]="properties" formControlName="shortTermRentalId" optionLabel="propertyCode"
                    optionValue="shortTermRentalId" [filter]="true" filterBy="propertyCode" [showClear]="false"
                    placeholder="Select Property">
                  </p-dropdown>
                  <label for="Select Property">Select Property</label>
                  @for (validation of validationMessages3.shortTermRentalId; track validation) {
                    <span>
                      @if (form3.get('shortTermRentalId').hasError(validation.type) && (form3.get('shortTermRentalId').dirty || form3.get('shortTermRentalId').touched)) {
                        <small class="p-invalid"
                          >{{validation.message}}
                        </small>
                      }
                    </span>
                  }
                </span>
              </div>
              <div class="col-lg-6  mb-4">
                <span class="p-float-label w-100">
                  <p-calendar formControlName="startDate" inputId="startDate" appendTo="body">
                  </p-calendar>
                  <label for="startDate">Start Date</label>
                  @for (validation of validationMessages3.startDate; track validation) {
                    <span>
                      @if (form3.get('startDate').hasError(validation.type) && (form3.get('startDate').dirty || form3.get('startDate').touched)) {
                        <small class="p-invalid"
                          >{{validation.message}}
                        </small>
                      }
                    </span>
                  }
                </span>
              </div>
              <div class="col-lg-6  mb-4">
                <span class="p-float-label w-100">
                  <p-calendar formControlName="endDate" inputId="endDate" appendTo="body">
                  </p-calendar>
                  <label for="endDate">End Date</label>
                  @for (validation of validationMessages3.endDate; track validation) {
                    <span>
                      @if (form3.get('endDate').hasError(validation.type) && (form3.get('endDate').dirty || form3.get('endDate').touched)) {
                        <small class="p-invalid"
                          >{{validation.message}}
                        </small>
                      }
                    </span>
                  }
                </span>
              </div>
            </div>
            <div class="col-lg-12">
            </div>
          </div>
        }
        @if (showGenerateFormByDate && !showBulkGenerateForm && !showGenerateForm) {
          <hr>
          }
          @if (showGenerateFormByDate && !showBulkGenerateForm && !showGenerateForm) {
            <div class="row m-0">
              <div class="col-lg-12">
                <div class="btn-group">
                  <div class="button-group">
                  </div>
                  <div class="button-group">
                    <button pButton class="btn-cancel p-button-text" [mat-dialog-close]="true">Cancel</button>
                    @if (!readOnlySubmitBotton) {
                      <button pButton class="btn-addt p-button" (click)="generateStatementByDate()">Generate Statement By Date</button>
                    }
                    @if (readOnlySubmitBotton) {
                      <button pButton class="btn-addt p-button" (click)="generateStatementByDate()" readonly="true">Submit</button>
                    }
                  </div>
                </div>
              </div>
            </div>
          }
        </div>
